import { render, staticRenderFns } from "./zhtj.vue?vue&type=template&id=2bfa3367&scoped=true"
import script from "./zhtj.vue?vue&type=script&lang=js"
export * from "./zhtj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfa3367",
  null
  
)

export default component.exports